import { initializeApp } from "https://www.gstatic.com/firebasejs/12.15.0/firebase-app.js";
import { getAnalytics } from "https://www.gstatic.com/firebasejs/12.15.0/firebase-analytics.js";
import { getRemoteConfig } from "https://www.gstatic.com/firebasejs/12.15.0/firebase-remote-config.js";

const firebaseConfig = {
  apiKey: "AIzaSyDKgItLCu1U1acOxWCe-aYt1GipYpED0UM",
  authDomain: "nomad-internet-main.firebaseapp.com",
  projectId: "nomad-internet-main",
  storageBucket: "nomad-internet-main.firebasestorage.app",
  messagingSenderId: "440892639579",
  appId: "1:440892639579:web:c6fe89c8542dcd7d6bf27e",
  measurementId: "G-VY7DCK90H7"
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(firebaseApp);
const firebaseRemoteConfig = getRemoteConfig(firebaseApp);
window.firebaseRemoteConfig = firebaseRemoteConfig;

firebaseRemoteConfig.settings.minimumFetchIntervalMillis = 1000;
// firebaseRemoteConfig.settings.minimumFetchIntervalMillis = 3600000;

firebaseRemoteConfig.defaultConfig = {
  "homepage_hero_image_url": "https://cdn.shopify.com/s/files/1/0103/2847/3658/files/woman-sitting-down-enjoying-nomad-internet.jpg?v=1780403788",
  // "homepage_hero_title": "Nomad Internet",
  // "homepage_hero_subtitle": "The fastest, most reliable internet for digital nomads.",
  // "homepage_hero_primary_cta_text": "Get Started",
  // "homepage_hero_primary_cta_url": "/get-started",
  // "homepage_hero_secondary_cta_text": "Learn More",
  // "homepage_hero_secondary_cta_url": "/learn-more"
};
